import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson } from '@client/core/data/concerns/parses-from-json';
import { HttpResponse } from '@client/core/http/types';
import { snakeCaseKeys } from '@client/core/utils/snake-case-keys';
import { WorkspaceCompany } from '@client/features/workspace-company/models/workspace-company';

export class WorkspaceCompanyDataSource extends DataSource {
  async findById(ownerId: number): Promise<WorkspaceCompany> {
    const response = await this.httpClient.get<HttpResponse<WorkspaceCompany>>(
      `/workspace/${ownerId}/workspace-company`,
    );

    return fromJson(WorkspaceCompany, response.data.data);
  }

  async createOrUpdate(ownerId: number, params: StoreWorkspaceCompanyParams): Promise<any> {
    const response = await this.httpClient.post<HttpResponse<WorkspaceCompany>>(
      `/workspace/${ownerId}/workspace-company`,
      snakeCaseKeys(params),
    );

    return fromJson(WorkspaceCompany, response.data.data);
  }
}

type StoreWorkspaceCompanyParams = Pick<WorkspaceCompany, 'investmentStrategy' | 'signupReason'>;
